document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('#js-service-download-form');
  if (!form) return;

  const submitButton = form.querySelector('input[type="submit"]');

  submitButton.addEventListener('click', function(e) {
    e.preventDefault();

    // エラーメッセージをクリア
    const errorElements = form.querySelectorAll('[data-error]');
    errorElements.forEach(el => {
      el.textContent = '';
    });

    // フォームデータを取得
    const companyName = form.querySelector('input[name="company_name"]').value;
    const name = form.querySelector('input[name="name"]').value;
    const position = form.querySelector('input[name="position"]').value;
    const emailAddress = form.querySelector('input[name="email_address"]').value;
    const phoneNumber = form.querySelector('input[name="phone_number"]').value;
    const articleCode = form.dataset.articleCode;

    const formData = {
      initial_response: {
        company_name: companyName,
        name: name,
        position: position,
        email_address: emailAddress,
        phone_number: phoneNumber,
        article_code: articleCode
      }
    };

    const submitForm = async () => {
      try {
        const response = await fetch('/api/service_download', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });
        const data = await response.json();

        if (data.success) {
          window.location.href = '/service_download_list/complete';
        } else {
          if (data.errors) {
            Object.keys(data.errors).forEach(key => {
              const errorElement = form.querySelector(`[data-error="${key}"]`);
              if (errorElement) {
                errorElement.innerHTML = data.errors[key].map(msg => `<p>${msg}</p>`).join('');
              }
            });
          }
        }
      } catch (error) {
        console.error('Error:', error);
        alert('送信中にエラーが発生しました。もう一度お試しください。');
      }
    };

    submitForm();
  });
});
